(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('OTPCodeController', OTPCodeController);

    OTPCodeController.$inject = ['$http', 'User', '$state', 'AlertService', 'Principal','$localStorage'];

    function OTPCodeController($http, User, $state, AlertService, Principal,$localStorage) {
        var vm = this;

        vm.userOtp = null;
        vm.otpError = false;
        var rememberMe = $localStorage.rememberMe;

        Principal.identity().then(function (account) {
            vm.twoFactorEmail = copyNotification(account);
        });

        var copyNotification = function (account) {
            return account.notification.twoFactorEmail;
        };

        function createOtp() {
            User.createOTP();
        }

        vm.checkOtp = function () {

            var body = 'otp=' + encodeURIComponent(vm.userOtp) +
            '&remember-me=' + rememberMe;
            $http.post('api/check-otp', body, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function () {
                delete $localStorage.rememberMe;
                Principal.identity(true).then(function () {
                    $state.go('tab-objects-dashboard');
                });
            }).error(function () {
                vm.otpError = true;
            });

        };

        vm.sendNew = function () {
            createOtp();
        };
    }
})();
